// extracted by mini-css-extract-plugin
export default {"SurveyRecordForm":"SurveyRecordForm_SurveyRecordForm__nu2e7","GeneralSection":"SurveyRecordForm_GeneralSection__bYTzw","LocationSection":"SurveyRecordForm_LocationSection__mc-aS"};